/**
 * Placement helpers for the preview row hover popup.
 * For Media Devoted | Created By Ciro Autiero
 */

export type HoverSide = 'left' | 'right';

export interface HoverPlacement {
  top: number;
  left: number;
  side: HoverSide;
}

const VIEWPORT_MARGIN = 12;
const CARD_OVERLAP = 6;
export const HOVER_BRIDGE_PX = 24;

export function computeHoverPlacement(trigger: DOMRect, card: DOMRect): HoverPlacement {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const fitsLeft = trigger.left >= card.width + VIEWPORT_MARGIN;
  const side: HoverSide = fitsLeft ? 'left' : 'right';
  const left =
    side === 'left'
      ? trigger.left - card.width + CARD_OVERLAP
      : Math.min(trigger.right - CARD_OVERLAP, vw - card.width - VIEWPORT_MARGIN);
  const centered = trigger.top + trigger.height / 2 - card.height / 2;
  const top = Math.max(
    VIEWPORT_MARGIN,
    Math.min(centered, vh - card.height - VIEWPORT_MARGIN),
  );
  return { top, left, side };
}

export function hoverShellStyle(placement: HoverPlacement): {
  top: number;
  left: number;
  paddingRight?: number;
  paddingLeft?: number;
} {
  const bridge = HOVER_BRIDGE_PX;
  if (placement.side === 'left') {
    return {
      top: placement.top,
      left: placement.left - bridge,
      paddingRight: bridge,
    };
  }
  return {
    top: placement.top,
    left: placement.left,
    paddingLeft: bridge,
  };
}
